import e, { useContext as r, createContext as n, useState as o, useMemo as t } from "react";
import a from "prop-types";
import { useEventListener as i } from "@leafygreen-ui/hooks";
import { getTheme as l } from "@leafygreen-ui/lib";
function u(e, r) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, r) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == n) return;
    var o,
      t,
      a = [],
      i = !0,
      l = !1;
    try {
      for (n = n.call(e); !(i = (o = n.next()).done) && (a.push(o.value), !r || a.length !== r); i = !0);
    } catch (e) {
      l = !0, t = e;
    } finally {
      try {
        i || null == n.return || n.return();
      } finally {
        if (l) throw t;
      }
    }
    return a;
  }(e, r) || function (e, r) {
    if (!e) return;
    if ("string" == typeof e) return p(e, r);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === n && e.constructor && (n = e.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(e);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return p(e, r);
  }(e, r) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function p(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var n = 0, o = new Array(r); n < r; n++) o[n] = e[n];
  return o;
}
var d = n({
    usingKeyboard: !0,
    setUsingKeyboard: function () {}
  }),
  c = {
    tab: 9,
    leftArrow: 37,
    upArrow: 38,
    rightArrow: 39,
    downArrow: 40
  };
function v() {
  return r(d);
}
function s(r) {
  var n = r.children,
    a = u(o(!1), 2),
    l = a[0],
    p = a[1];
  i("mousedown", function () {
    return p(!1);
  }, {
    enabled: l
  }), i("keydown", function (e) {
    var r = e.keyCode;
    Object.values(c).includes(r) && p(!0);
  }, {
    enabled: !l
  });
  var v = t(function () {
    return {
      usingKeyboard: l,
      setUsingKeyboard: p
    };
  }, [l]);
  return e.createElement(d.Provider, {
    value: v
  }, n);
}
s.displayName = "UsingKeyboardProvider", s.propTypes = {
  children: a.node
};
var f = {
    popover: {
      portalContainer: void 0,
      scrollContainer: void 0
    }
  },
  y = n(f);
function m() {
  return r(y).popover;
}
function b(r) {
  var n = r.popover,
    o = void 0 === n ? f.popover : n,
    t = r.children;
  return e.createElement(y.Provider, {
    value: {
      popover: o
    }
  }, t);
}
var h = n({
  isPopoverOpen: !1,
  setIsPopoverOpen: function () {}
});
function g() {
  return r(h);
}
function P(r) {
  var n = r.children,
    a = u(o(!1), 2),
    i = a[0],
    l = a[1],
    p = t(function () {
      return {
        isPopoverOpen: i,
        setIsPopoverOpen: l
      };
    }, [i]);
  return e.createElement(h.Provider, {
    value: p
  }, n);
}
P.displayName = "PopoverProvider", P.propTypes = {
  children: a.node
};
var k = n(14);
function w() {
  return r(k);
}
function M(r) {
  var n = r.children,
    o = r.baseFontSize,
    t = void 0 === o ? 14 : o;
  return e.createElement(k.Provider, {
    value: t
  }, n);
}
M.displayName = "TypographyProvider", M.propTypes = {
  children: a.node,
  baseFontSize: a.number
};
var A = n({
    globalDarkMode: !1
  }),
  E = function () {
    return r(A);
  },
  S = function (e) {
    var r,
      n = E().globalDarkMode,
      o = null !== (r = null != e ? e : n) && void 0 !== r && r;
    return {
      darkMode: o,
      theme: l(o)
    };
  };
function T(r) {
  var n = r.children,
    o = r.globalDarkMode,
    t = void 0 !== o && o;
  return e.createElement(A.Provider, {
    value: {
      globalDarkMode: t
    }
  }, n);
}
function C(r) {
  var n = r.children,
    o = r.baseFontSize,
    t = r.popoverPortalContainer,
    a = r.darkMode;
  return e.createElement(s, null, e.createElement(b, {
    popover: t
  }, e.createElement(M, {
    baseFontSize: o
  }, e.createElement(T, {
    globalDarkMode: a
  }, n))));
}
T.displayName = "DarkModeProvider", T.propTypes = {
  children: a.node,
  globalDarkMode: a.bool
}, C.displayName = "LeafyGreenProvider", C.propTypes = {
  popoverPortalContainer: a.shape({
    popover: a.shape({
      portalContainer: a.elementType,
      scrollContainer: a.elementType
    })
  }),
  baseFontSize: a.oneOf([14, 16]),
  darkMode: a.bool
};
export { h as PopoverContext, P as PopoverProvider, b as PortalContextProvider, C as default, w as useBaseFontSize, S as useDarkMode, E as useDarkModeContext, g as usePopoverContext, m as usePopoverPortalContainer, v as useUsingKeyboardContext };